import packageJson from "../package.json";

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  swaggerUrl: string;
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: "admin",
  appVersion: packageJson.version,
  swaggerUrl: import.meta.env.VITE_SWAGGER_API_URL ?? "",
};
